import { findSlotsByScheduleIds } from '@/app/(main)/(pages)/_services/search-api/search-api.service';
import { SearchApiDayTime, SearchApiScheduleSlot } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { SchedulesSearchSlot, SlotStatus } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';

export interface GETScheduleSlotParams {
  limitDays: number;
  offsetDays: number;
  id: string;
  dayTime?: SearchApiDayTime;
  minDate?: string;
  maxDate?: string;
}

export interface GETSchedulesSlotsParams extends Omit<GETScheduleSlotParams, 'id'> {
  ids: string[];
}

export interface GETScheduleSlotResult {
  slots: SchedulesSearchSlot[];
  hasMore: boolean;
}

function toSchedulesSearchSlot(slot: SearchApiScheduleSlot, scheduleId: string): SchedulesSearchSlot {
  return {
    id: slot.id,
    date: slot.date,
    start: slot.start,
    end: slot.end,
    status: slot.status?.toUpperCase() === 'AVAILABLE' ? SlotStatus.AVAILABLE : SlotStatus.UNAVAILABLE,
    type: slot.type,
    scheduleId,
  };
}

export async function getSchedulesSlotsByIds({
  ids, limitDays, offsetDays, dayTime, minDate, maxDate,
}: GETSchedulesSlotsParams): Promise<GETScheduleSlotResult> {
  const { groups, hasMore } = await findSlotsByScheduleIds(ids, {
    limitDays, offsetDays, dayTime, minDate, maxDate,
  });
  const requestedIds = new Set(ids);

  const slots = groups
    .filter((group) => requestedIds.has(group.scheduleId))
    .flatMap((group) => (group.slots ?? []).map((slot) => toSchedulesSearchSlot(slot, group.scheduleId)));

  return { slots, hasMore };
}

export async function getSchedulesSlotById({ id, ...params }: GETScheduleSlotParams): Promise<GETScheduleSlotResult> {
  return getSchedulesSlotsByIds({ ids: [id], ...params });
}
